import { Tab, Tabs } from "@blueprintjs/core";
import { useState } from "react";
import { Trans } from "react-i18next";
import DetectionClassificationSettings from "../../Settings/DetectionClassification/DetectionClassification";
import Title from "../../Structure/logo";
import ServerSelect from "../../Structure/ServerSelector";
import History from "./History";
import Lanes from "./Lanes/Lanes";
import Performances from "./Performances/Performances";
import Sensors from "./Sensors/Sensors";

export default function DetectionClassification() {
  const [server, setServer] = useState(0);
  return (
    <div className="component-body">
      <Title icon="unknown-vehicle" text={<Trans>ALPR</Trans>} />
      <Tabs
        id="settingmenu"
        fill={true}
        vertical={true}
        renderActiveTabPanelOnly={true}
        defaultSelectedTabId="dh"
      >
        <ServerSelect onSelect={(id, srv) => setServer(id)} />

        <Tab
          id="dh"
          title={<Trans>history</Trans>}
          icon="history"
          panel={<History srv={server} />}
        />

        {localStorage.getItem("perm_admin") === "true" && (
          <Tab
            id="dp"
            title={<Trans>Performances</Trans>}
            icon="chart"
            panel={<Performances srv={server} />}
          />
        )}

        {localStorage.getItem("perm_admin") === "true" && (
          <Tab
            id="dl"
            title={<Trans>lanes</Trans>}
            icon="horizontal-distribution"
            panel={<Lanes srv={server} />}
          />
        )}

        {localStorage.getItem("perm_admin") === "true" && (
          <Tab
            id="dd"
            title={<Trans>cameras</Trans>}
            icon="mobile-video"
            panel={<Sensors srv={server} />}
          />
        )}

        {localStorage.getItem("perm_admin") === "true" && (
          <Tab
            id="ds"
            title={<Trans>settings</Trans>}
            icon="settings"
            panel={<DetectionClassificationSettings srv={server} />}
          />
        )}
      </Tabs>
    </div>
  );
}
